import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { Chip } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { StyledCopy } from "../../../styles/styledCopy";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import RenderStatus from "../../../styles/styledStatus";

const TelegramInvoicesItem = ({ invoice, setNotification, t }) => {

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <StyledTableRow
      scroll="auto"
      col="13"
      as={NavLink}
      to={`/payments/${invoice.paymentId}`}
      onClick={(e) => {showDetails(e);}}
      className="invoices__row"
    >
      <StyledCol inline data-title={t("invoices.table.inv")}>
        <CopyToClipboard
          className="stop-event"
          text={`#INV-${invoice.shortId}`}
          onCopy={() => setNotification({ visible: true, type: "success", message: t("common.copied") })}
        >
          <StyledBreakWord as="p">
            #INV-{invoice.shortId} <StyledCopy title={t("common.copy")} className="icon-light-copy" />
          </StyledBreakWord>
        </CopyToClipboard>
        {invoice.currencySwitched && (
          <Chip label="switch" size="small" variant="outlined" style={{ fontSize: 10, marginLeft: 4 }} />
        )}
      </StyledCol>
      <StyledCol data-title={t("invoices.table.paymentId")}>
        {invoice.paymentId}
      </StyledCol>
      <StyledCol data-title={t("invoices.table.project")}>
        {invoice.projectName || "--"}
      </StyledCol>
      <StyledCol data-title={t("invoices.table.chat")}>
        {invoice.chatTitle || `#${invoice.chatId}`}
      </StyledCol>
      <StyledCol data-title={t("invoices.table.manager")}>
        {invoice.managerName}
      </StyledCol>
      <StyledCol data-title={t("invoices.table.type")}>
        {invoice.managerType}
      </StyledCol>
      <StyledCol data-title={t("invoices.table.amount")}>
        {parseFloat(invoice.invoiceAmount).toFixed(8)}
      </StyledCol>
      <StyledCol data-title={t("invoices.table.commission")}>
        {parseFloat(invoice.commissionAmount).toFixed(8)}
      </StyledCol>
      <StyledCol data-title={t("invoices.table.total")}>
        <strong>{parseFloat(invoice.totalAmount).toFixed(8)}</strong>
      </StyledCol>
      <StyledCol data-title={t("invoices.table.currency")}>
        {invoice.currency}
      </StyledCol>
      <StyledCol data-title={t("invoices.table.network")}>
        {invoice.network}
      </StyledCol>
      <StyledCol inline data-title={t("invoices.table.status")}>
        <RenderStatus status={invoice.status.toUpperCase()} />
      </StyledCol>
      <StyledCol data-title={t("invoices.table.time")}>
        {TimestampToDateMoment(invoice.createdAt)}
      </StyledCol>
    </StyledTableRow>
  );
};

export default TelegramInvoicesItem;
